import React from "react";
import { MakeLabelParams } from "../../types/MakeLabelParams";
import { AttrLinkedLabel } from "./AttrLinkedLabel/AttrLinkedLabel";

export const makeAttrLinkedLabel = (data: MakeLabelParams) => (
  <AttrLinkedLabel params={data} />
);
